import { Link } from 'react-router-dom';
import type { Project } from '../types';
import { PROJECT_STATUS_LABELS } from '../types';
import { useAppData } from '../store';
import { formatUSD } from '../lib/format';

export default function ProjectCard({ project }: { project: Project }) {
  const { getProperty } = useAppData();
  const property = getProperty(project.property_id);

  return (
    <Link to={`/projects/${project.id}`} className={`card project-card status-${project.status}`}>
      <div className="project-card-main">
        <div className="project-card-title">
          <span className="name">{project.name}</span>
          <span className={`badge status-${project.status}`}>
            {PROJECT_STATUS_LABELS[project.status]}
          </span>
        </div>
        <div className="project-card-sub muted">
          {property ? property.name : 'No property'}
          {project.target_timeframe ? ` · ${project.target_timeframe}` : ''}
        </div>
      </div>
      {project.estimated_budget != null && (
        <div className="project-card-meta muted">{formatUSD(project.estimated_budget)}</div>
      )}
    </Link>
  );
}
